export const HTTP_DUPLICATE_STATUS = '409';

export const FUNCTION = 'function';
